import type { AIAvatar, AIAvatarVoicePreset } from 'js/src/client';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import { type DeepReadonly, withStableEmptyArray } from 'js/src/libs/consts';
import type { RootState } from 'js/src/libs/RootState';

export function getAIAvatarVoicePresetsOrm(state: RootState) {
    return new PlainJsStoreORM(state.aiVoicesAndAvatars.aiAvatarVoicePresets);
}

export function getAIAvatarVoicePresetIds(state: RootState): readonly number[] {
    return withStableEmptyArray(state.aiVoicesAndAvatars.aiAvatarVoicePresets.allIds);
}

export function getAIAvatarVoicePresetById(
    state: RootState,
    id: number,
): DeepReadonly<AIAvatarVoicePreset> | null {
    const orm = getAIAvatarVoicePresetsOrm(state);
    if (!id || orm.isEmpty()) {
        return null;
    }
    return orm.getByIdOrThrow(id);
}

export function getAIAvatarVoicePresetByAvatarId(
    state: RootState,
    avatarId: number,
): DeepReadonly<AIAvatarVoicePreset> | null {
    return (
        getAIAvatarVoicePresetsOrm(state).find((preset) => preset.avatar_id === avatarId) ?? null
    );
}

export function getAIAvatarsOrm(state: RootState) {
    return new PlainJsStoreORM(state.aiVoicesAndAvatars.aiAvatars);
}

export function getAIAvatarIds(state: RootState): readonly number[] {
    return withStableEmptyArray(state.aiVoicesAndAvatars.aiAvatars.allIds);
}

export function getAIAvatarById(state: RootState, id: number): DeepReadonly<AIAvatar> | null {
    return getAIAvatarsOrm(state).getById(id) ?? null;
}

export function getIsAIVoiceoverBatchComplete(state: RootState): boolean {
    return state.aiVoicesAndAvatars.aiVoiceoverBatchComplete;
}
